'use strict'

import axios from 'axios'

import * as types from './constants/mutation-types'

export const getEventsJson = ({ commit }) => {
  return axios.get('/data/events.json')
    .then(response => {
      commit(types.UPDATE_EVENTS_JSON_LOADED, true)
      commit(types.UPDATE_EVENTS_JSON, response.data)
    })
    .catch(response => {
      console.error(response)
    })
}
